import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function AppointmentSearch({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item label="Data Inicial" name={[fieldName, 'action', 'data', 'data_start']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="Data Final" name={[fieldName, 'action', 'data', 'data_end']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="ID do Profissional" name={[fieldName, 'action', 'data', 'profissional_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="ID do Paciente" name={[fieldName, 'action', 'data', 'paciente_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="ID do Agendamento" name={[fieldName, 'action', 'data', 'agendamento_id']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
    </>
  )
}
